import BaseService from "services/base";
import { builder } from "utils/graphql";
import { WARD_SELECTION } from "./constant";

class WardService extends BaseService {
  static override DEFINITION = builder.createDefinition({
    name: "Ward",
    baseQuery: "Ward",
    baseSelection: `
      ${WARD_SELECTION}
    `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
    },
    GQL_ACTIONS: {
      FIND: "Wards",
    },
    GQL_RESPONSE_DATA_PATH: {
      FIND: "data.Wards.docs",
      PARAMS: "data.Wards",
    },
  });
}

const Instance = new WardService();
export default Instance;
